export default __webpack_public_path__ + "static/media/telefono.041c3702.svg";